$('.accordion-title').on('click',function(event) {
    event.preventDefault();
    let currenSlide = $(this);

    if(currenSlide.hasClass('active')){
        currenSlide.removeClass('active');
        currenSlide.next('.accordion-description').slideUp();
    }else{
         currenSlide.addClass('active');
        currenSlide.next('.accordion-description').slideDown();
    }
})